import withSharedStyles from "../theme/Shared.style";

// Product grid cells: ~168px+ columns, 20px gutters × 32px rows
// (2 per row on phones, 4 under 1100, 4–6 on desktop).
const withCustomStyles = withSharedStyles(theme => ({
  tileItem: {
    padding: "0 10px 32px",
    [theme.media.phone]: {
      padding: "0 6px 24px"
    }
  }
}));

export default withCustomStyles;
